import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/core/services/alert.service';
import { ShippingService } from 'src/core/services/shipping.service';
import { UtilsService } from 'src/core/services/utils.service';
import { Order, TrackingDetails } from 'src/interfaces/order';

interface DialogData {
  order: Order;
  title: string;
  message: string;
  trackingDetails?: TrackingDetails[];
}

@Component({
    selector: 'app-order-track-dialog',
    templateUrl: './order-track-dialog.component.html',
    styleUrls: ['./order-track-dialog.component.scss'],
    standalone: false
})
export class OrderTrackDialogComponent implements OnInit {

  trackingDetails: TrackingDetails[] = [];
  order: Order | null = null;

  constructor(
    public _dialogRef: MatDialogRef<OrderTrackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _shippingService: ShippingService,
    public utilService: UtilsService,
    private _alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.order = this.data.order;
    this.applyTracking(this.resolveTracking());
  }

  get trackingDetailsIsEmpty(): boolean {
    return this.trackingDetails.length === 0;
  }


  async refresh() {

    if(!this.order) {
      this._alertService.errorAlert("An error occured retrieving order");
      return;
    }

    const trackingDetails = await this._shippingService.trackOrder(this.order.id);
    this.applyTracking(trackingDetails);
  }

  /** Prefer the track response. Fall back to tracking already on the order. */
  private resolveTracking(): TrackingDetails[] {
    if (this.data.trackingDetails?.length) {
      return this.data.trackingDetails;
    }

    return this.order?.shipping_details?.tracking_details ?? [];
  }

  private applyTracking(details: TrackingDetails[] | null | undefined): void {
    const list = Array.isArray(details) ? details : [];

    this.trackingDetails = [...list].sort((a: TrackingDetails, b: TrackingDetails) => {
      const dateA = new Date(a.tracking?.dateAndTime).getTime();
      const dateB = new Date(b.tracking?.dateAndTime).getTime();

      return dateB - dateA;
    });
  }

  get latestDetails(): TrackingDetails | null {
    if(this.trackingDetails.length === 0) return null;
    
    return this.trackingDetails[0];
  }




}
